"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const StepIcon_1 = __importDefault(require("@material-ui/core/StepIcon"));
const styles_2 = __importDefault(require("./styles"));
exports.StepIcon = props => {
    const { icon } = props;
    return react_1.default.createElement(StepIcon_1.default, { icon: icon });
};
exports.StepIcon.displayName = 'StepIcon';
exports.default = styles_1.withStyles(styles_2.default)(exports.StepIcon);
//# sourceMappingURL=StepIcon.js.map